import React from "react";
import { Tooltip, TooltipProps } from "antd";

const CustomToolTip: React.FC<TooltipProps> = ({ ...props }) => (
  <Tooltip {...props}></Tooltip>
);

export default CustomToolTip;
